import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { CREATE_TUTOR, CREATE_TUTOR_FAIL, CREATE_TUTOR_SUCCESS, CreateTutorActionType } from '../redux/tutorReducer'

function* CreateTutorFlow(action: CreateTutorActionType): Generator<any, void, any> {
  try {
    const params = { tutor: action.payload }
    const response = yield call(apiCall, { endpoint: '/tutors/tutors', method: 'POST', params })
    yield put(CREATE_TUTOR_SUCCESS(response))
  } catch (error) {
    yield put(CREATE_TUTOR_FAIL())
    console.log(error)
  }
}

export default function* CreateTutorSaga(): Generator<any, void, any> {
  yield takeLatest([CREATE_TUTOR], CreateTutorFlow)
}
